// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__AxGJw","mainContainerInner":"Main_mainContainerInner__CRU-6","side":"Main_side__BOmHk"};